export enum ClusterOnboardingActions {
  CONNECTWIFI = 1,
  CONFIGUREMASTER = 2
}
